import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import './WhatsAppButton.css';

const WhatsAppButton = () => {
  const phoneNumber = '33661630113';
  const defaultMessage = encodeURIComponent(
    'Bonjour VIP Limousine Paris, je souhaite obtenir de plus amples informations.'
  );
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${defaultMessage}`;

  return (
    <a
      href={whatsappUrl}
      className="whatsapp-button"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contacter VIP Limousine Paris sur WhatsApp"
    >
      <FaWhatsapp size={24} />
      <span>WhatsApp</span>
    </a>
  );
};

export default WhatsAppButton;
